import { writeCart } from '@/helpers/cart';
import { openSitePage } from '@/helpers/embed-navigation';
import { CartData } from '@/lib/types';

export const isEmbedded = () => window.self !== window.top;

const buildCheckoutUrl = (cart: CartData) => {
  const url = new URL('/checkout', window.location.origin);
  url.hash = `cart=${encodeURIComponent(JSON.stringify(cart))}`;
  return url.toString();
};

// A pop-up blocker only honours window.open inside the click that triggered it,
// so a caller that awaits before navigating has to reserve its tab up front.
export const reserveCheckoutTab = () =>
  isEmbedded() ? window.open('', '_blank') : null;

// Checkout cannot run inside an embed frame — the session cookie is
// third-party there — so the embed opens it as its own tab and carries the cart
// in the URL rather than through frame storage, which is partitioned from the
// new tab and throws outright when third-party storage is blocked.
// Returns false when the tab could not be opened, so the caller can say so.
export const goToCheckout = (
  router: { push: (href: string) => void },
  cart: CartData,
  reservedTab?: Window | null
) => {
  if (!isEmbedded()) {
    writeCart(cart);
    router.push('/checkout');
    return true;
  }

  const url = buildCheckoutUrl(cart);
  if (reservedTab) {
    reservedTab.location.href = url;
    return true;
  }

  return openSitePage(url);
};
